export default __webpack_public_path__ + "static/media/BrakeMaintenance3.3154a609.png";